import React from 'react';
import MaterialListItemText from '@mui/material/ListItemText';
import type {ListItemTextProps as MaterialListItemTextProps} from '@mui/material/ListItemText';

export type ListItemTextProps = MaterialListItemTextProps;

export const ListItemText = React.forwardRef<any, ListItemTextProps>(
    (
        {...props},
        ref
    ) => {
        return (
            <MaterialListItemText
                ref={ref}
                {...props}
            />
        );
    });

ListItemText.displayName = 'ListItemText';
